import React, { useCallback } from 'react';
import { getIn } from 'formik';

import { TextField } from '../../text-field';
import { FieldElementPropTypes } from '../propTypes';

const StringField = ({
  field: { id, name, label, mode, value, optional, onChange: customOnChange, ...props },
  ctx: { handleChange, touched, errors, classes, setFieldTouched, setFieldValue }
}) => {
  const onChange = useCallback(
    (e) => {
      handleChange(e);
      setFieldValue(id, e.target.value);
      setFieldTouched(id, true, false);
      if (customOnChange) {
        customOnChange(e.target.value, id || name);
      }
    },
    [handleChange, setFieldTouched, id, customOnChange, name, setFieldValue]
  );

  return (
    <TextField
      key={id}
      id={id}
      name={name || id}
      label={label}
      value={value || ''}
      onChange={onChange}
      error={getIn(touched, name || id) && !!getIn(errors, name || id)}
      helperText={getIn(touched, name || id) && getIn(errors, name || id)}
      mode={mode}
      fullWidth
      classes={classes[id]}
      {...props}
    />
  );
};

StringField.propTypes = FieldElementPropTypes;

export default StringField;
